import React from "react";
import "./EmptyState.css";

interface EmptyStateProps {
  icon?:    string;
  message:  string;
}

export default function EmptyState({ icon = "○", message }: EmptyStateProps) {
  return (
    <div className="aro-empty-state">
      <span className="aro-empty-state__icon">{icon}</span>
      <p className="aro-empty-state__message">{message}</p>
    </div>
  );
}
